import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getTranslation } from '@shared/translate-helper';

@Component({
  selector: 'app-bad-request',
  templateUrl: './bad-request.component.html',
  styleUrls: ['./bad-request.component.scss'],
  standalone: false,
})
export class BadRequestComponent {
  public errorCode: string = '400';
  public errorTitle!: string;
  public errorDescription!: string;
  public quickTip!: string;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    getTranslation(this.translateService, ['400_title', '400_description', '400_quick_tip']).subscribe((t) => {
      this.errorTitle = t['400_title'];
      this.errorDescription = t['400_description'];
      this.quickTip = t['400_quick_tip'];
    });
  }
}
